import { styled } from '@mui/material/styles';

export const LoaderWrapper = styled('div')(({ theme }) => ({
  width: '100%',
  justifyContent: 'center',
  display: 'flex'
}));
